/*
 * @Date: 2023-12-29 10:38:30
 * @Author: jm
 * @LastEditTime: 2024-06-20 19:49:51
 * @LastEditors: jm
 * @FilePath: \arcadearchipelago\src\pages\home\main.js
 * @Description:
 */
import Vue from "vue";
import App from "../../App.vue";
import router from "./router";
import store from "./store";
import LazyLoad from "@/directives/lazy";
import "../../utils/flexible.js";
import "../../styles/index.scss";

Vue.use(LazyLoad, {
  default: require("../../assets/images/loading.gif"),
});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
